import api from '@/services/api/config';

const path = 'v1/prozesskontrollkarte/kontrollintervall';

export default {
  getById: (id) => api.get(`${path}/${id}`),
  get: (page, size, sort = null, desc = false, suche = null) => api.get(path, {
    params: {
      page, size, sort, desc, suche,
    },
  }),
  create: (kontrollintervall) => api.post(path, kontrollintervall),
  delete: (id) => api.delete(`${path}/${id}`),
};
